import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Button, Card, CardContent, Divider, Box } from '@mui/material';

import { t } from 'i18next';
import {
    getQuestionnaireByUUID,
    getQuestionnaireQuestions
} from '../../../services/questionnaire';
import QuestionnaireViewer from '../QuestionnaireViewer/QuestionnaireViewer';
import BulkAssignDialog from './BulkAssignDialog';

const QuestionnaireDetails = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();

    const [questionnaire, setQuestionnaire] = useState(null);
    const [questions, setQuestions] = useState([]);

    const [openAssignDialog, setOpenAssignDialog] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const metadata = await getQuestionnaireByUUID(uuid);
                const questions = await getQuestionnaireQuestions(uuid);
                setQuestionnaire(metadata);
                setQuestions(questions);
            } catch (err) {
                console.error('Erro ao procurar questionário:', err);
            }
        };

        fetchData();
    }, [uuid]);

    if (!questionnaire) return <Typography>{t('plansDetails.loading')}</Typography>;

    return (
        <Card sx={{ m: 2 }}>
            <CardContent>
                <Box display="flex" gap={2}>
                    <Button variant="contained" onClick={() => setOpenAssignDialog(true)}>
                        {t('questionnaires.assign_quest')}
                    </Button>
                </Box>
                <BulkAssignDialog
                    open={openAssignDialog}
                    onClose={() => setOpenAssignDialog(false)}
                    questionnaireUUIDs={[uuid]}
                />

                <Divider sx={{ my: 2 }} />

                <QuestionnaireViewer
                    title={questionnaire.name}
                    description={questionnaire.description}
                    formData={questions.filter((step) => step.id !== '1')}
                    previewMode={true}
                />

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button variant="outlined" onClick={() => navigate('/questionarios')}>
                        {t('plansDetails.back')}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default QuestionnaireDetails;
